import cn from "classnames";
import { useState } from "react";
import { Text } from "shared/components/Text";
import css from "./styles.module.scss";

export const AdditionalItem = ({ additional, className, style, color }) => {
  const isMobile = window.matchMedia("(max-width: 1060px)").matches;

  const [showHidden, setShowHidden] = useState(false);

  const handleHover = () => {
    setShowHidden(true);
  };

  const handleLeave = () => {
    setShowHidden(false);
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cn(css.additionalItem, css.clipPath, className)}
      style={style}
      onMouseOver={!isMobile ? handleHover : null}
      onMouseLeave={!isMobile ? handleLeave : null}
      onClick={isMobile ? () => setShowHidden(!showHidden) : null}
    >
      <polygon points="140,0 280,140 140,280 0,140" fill="#43315b" />
      <foreignObject className={cn(css.additionalItem, className)}>
        <div
          className={cn(
            css.additionalItem,
            css.additionalItemWithPadding,
            css[color],
            {
              [css.dimmedContent]: showHidden,
            }
          )}
        >
          <img src={additional.img} className={css.img} />
          <div className={css.contentContainer}>
            <Text
              type="white"
              className={css.additionalTitle}
              secondaryFamily
              size="body"
            >
              {additional.content}
            </Text>
          </div>
          {showHidden && (
            <div className={css.hiddenContainer}>
              <Text
                type="white"
                className={css.hiddenContent}
                secondaryFamily
                size="body"
              >
                {additional.hidden}
              </Text>
            </div>
          )}
        </div>
      </foreignObject>
    </svg>
  );
};
